<div class="project-list-container">

  <div class="project-list-actions">
    <ng-casto-button class="primary" [faIcon]="faSearch" (click)="filterDisplayedProjects()"></ng-casto-button>
    <p-floatLabel>
      <input pInputText id="searchCustomerInfoProject" [(ngModel)]="searchInputValue"
             (keyup.enter)="filterDisplayedProjects()" />
      <label for="searchCustomerInfoProject" [innerHTML]="'project-list.search-placeholder' | translate"></label>
    </p-floatLabel>
    <p-floatLabel>
      <p-dropdown
        [options]="contextDropdownItems"
        [(ngModel)]="selectedContext"
        optionLabel="name"
        inputId="selectCustomerInfoContext"
        (onChange)="setTabFromDropdown($event)" />
      <label for="selectCustomerInfoContext" [innerHTML]="'project-list.project-type-placeholder' | translate"></label>
    </p-floatLabel>
    <p-splitButton
      [label]="'search-bar.create-project' | translate"
      styleClass="casto-split-button"
      [model]="contextProjectDropdownItems"
      (onClick)="openDropdown()"
      id="customer-info-create-project" />
  </div>

  <div class="project-list-items">
    @if (!loading) {
      @if (displayedProjects.length > 0) {
        @for (project of displayedProjects; track project) {
          <div class="project-item-container">
            <div class="project-thumbnail"
                 [class]="project.distributionID === contexts.BATHROOM_V2 ? 'bathroomV2-thumbnail' : null">
              <img [src]="project.thumb | safe" alt="thumbnail">
              <div class="actions-overlay">
                <ng-casto-button
                  class="primary"
                  (click)="openProject(project, $event)"
                  [label]="'popins.projects.open_project' | translate"></ng-casto-button>
                <ng-casto-button class="secondary borderless" [faIcon]="faTrash"
                                 [disabled]="isProjectDeleteDisabled(project)"
                                 (click)="deleteProject(project, $event)"></ng-casto-button>
                <ng-casto-button class="secondary borderless" [faIcon]="faCopy"
                                 (click)="duplicateProject(project, $event)"></ng-casto-button>
              </div>
            </div>
            <div class="project-info">
              <div class="project-title">
                <span>{{ project.projectName }}</span>
              </div>
              <div class="project-detail">
                <p [innerHtml]="project.description | nl2br"></p>
                <p class="project-date">{{ project.dateUpdate | date: 'd/MM/y H:mm' }}</p>
              </div>
              <div class="project-tag">
                @if (project.hasQuotation) {
                  <div class="quotation">
                    <p>{{ 'popins.projects.quotation' | translate }}</p>
                    <p class="expiration-date">
                      {{ 'popins.projects.quotation-expiration' | translate }}
                      {{ project.quotationExpirationDate | date: 'dd/MM/y' }}
                    </p>
                  </div>
                }
                @if (project.hasDiscount && project.hasQuotation) {
                  <div class="quotation">
                    <p>{{ 'popins.projects.quotation-discount' | translate }}</p>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      }
    } @else {
      @for (item of projectSkeletonItems; track $index) {
        <div class="project-item-container skeleton-project-item">
          <div class="project-thumbnail">
            <p-skeleton width="100%" height="11rem"></p-skeleton>
          </div>
          <div class="project-info">
            <p-skeleton width="75%" height="1.1rem"></p-skeleton>
            <p-skeleton width="55%" height="0.9rem"></p-skeleton>
            <p-skeleton width="88%" height="3rem" borderRadius="20px"></p-skeleton>
          </div>
        </div>
      }
    }
  </div>

</div>
